import { OepaUserAccount } from "@ohioepa/oepa-common-lib";

export const intLiveReloadAccount: OepaUserAccount = {
    loginName: 'sd',
    accountID: 'sd',
    firstName: 'Sam',
    lastName: 'Davis',
    primaryEMailAddress: 'samuel.davis@epa.ohio.gov',
    type: 'E_BUSINESS_CENTER', // options: APPLICATION_PORTAL, E_BUSINESS_CENTER
    roleList: [
      {
      	name: 'AsbestosRoles',
      	description: 'Custom Asbestos Roles',
      	privilegeList: [
            { type: 'VIEW_CORE_PLACE', name: '' },
            { type: 'CREATE_ASBESTOS_NOTIF', name: 'Create Notification' },
            { type: 'VIEW_ANY_ASBESTOS_NOTIF', name: 'View Any Notification' },
            { type: 'EDIT_ASBESTOS_NOTIF', name: 'Edit Notification' },
            { type: 'EDIT_SUBMIT_ANY_ASBESTOS_NOTIF', name: 'Edit Submitted Notification' },
            { type: 'DELETE_ASBESTOS_NOTIF', name: 'Delete Notification' },
            { type: 'CANCEL_ASBESTOS_NOTIF', name: 'Cancel Notification' },
            { type: 'REVIEW_ASBESTOS_NOTIF', name: 'Review Notification' },
            { type: 'ASSIGN_INSPECT_ASBESTOS_NOTIF', name: 'Assign Inspection Notification' },
            { type: 'INVOICE_ASBESTOS_NOTIF', name: 'Invoice Notification' },
            { type: 'REASSIGN_DOLAA_NOTIF', name: 'Reassign DOLAA Notification' },
            { type: 'CREATE_NOTE_NOTIF', name: 'Create Note Notification' },
            { type: 'DELETE_ANY_NOTE_NOTIF', name: 'Delete Any Note Notification' },
            { type: 'DELETE_OWN_NOTE_NOTIF', name: 'Delete Own Note Notification' },
            { type: 'VIEW_NOTIF_INVOICE', name: 'View Notification Invoice' },
            { type: 'PROCESS_NOTIF_INVOICE', name: 'Process Notification Invoice' },

            { type: 'VIEW_ANY_INSPECTION', name: 'View Any Inspection' },
            { type: 'CREATE_INSPECTION', name: 'CreateInspection' },
            { type: 'EDIT_OWN_INSPECTION', name: 'EditOwnInspection' },
            { type: 'EDIT_ANY_INSPECTION', name: 'EditAnyInspection' },
            { type: 'REVIEW_INSPECTION', name: 'ReviewInspection' },
            { type: 'EDIT_SETTINGS_INSPECTION', name: 'EditSettingInspection' },
            { type: 'VIEW_ANY_ASBESTOS_LIC', name: '' },
            { type: 'CREATE_ASBESTOS_LIC', name: '' },
            { type: 'EDIT_ANY_ASBESTOS_LIC', name: '' },
            { type: 'DELETE_ASBESTOS_LIC', name: '' },
            { type: 'CANCEL_ASBESTOS_LIC', name: '' },
            { type: 'REVIEW_ASBESTOS_LIC', name: '' },
            { type: 'CREATE_NOTE_ASBESTOS_LIC', name: '' },
            { type: 'DELETE_ANY_NOTE_ASBESTOS_LIC', name: '' },
            { type: 'DELETE_OWN_NOTE_ASBESTOS_LIC', name: '' },

            { type: 'VIEW_ANY_ASBESTOS_CERT', name: '' },
            { type: 'CREATE_ASBESTOS_CERT', name: '' },
            { type: 'EDIT_ANY_ASBESTOS_CERT', name: '' },
            { type: 'DELETE_ASBESTOS_CERT', name: '' },
            { type: 'CANCEL_ASBESTOS_CERT', name: '' },
            { type: 'REVIEW_ASBESTOS_CERT', name: '' },
            { type: 'CREATE_NOTE_ASBESTOS_CERT', name: '' },
            { type: 'DELETE_ANY_NOTE_ASBESTOS_CERT', name: '' },
            { type: 'DELETE_OWN_NOTE_ASBESTOS_CERT', name: '' },

            { type: 'VIEW_ANY_ASBESTOS_CM', name: '' },
            { type: 'CREATE_ASBESTOS_CM', name: '' },
            { type: 'EDIT_ANY_ASBESTOS_CM', name: '' },
            { type: 'DELETE_ASBESTOS_CM', name: '' },
            { type: 'CANCEL_ASBESTOS_CM', name: '' },
            { type: 'REVIEW_ASBESTOS_CM', name: '' },
            { type: 'CANCEL_ASBESTOS_CM', name: '' },
            { type: 'CREATE_NOTE_ASBESTOS_CM', name: '' },
            { type: 'DELETE_ANY_NOTE_ASBESTOS_CM', name: '' },
            { type: 'DELETE_OWN_NOTE_ASBESTOS_CM', name: '' },
      	]
      }
    ]
  }